import { ErrorState, LazyLoader } from '@bp/ui-components';
import classNames from 'classnames';
import type React from 'react';
import type { FC } from 'react';
import styles from './BpSubpage.module.scss';

type BpSubpageProps = {
  fullWidth?: boolean;
  fullHeight?: boolean;
  isForbidden?: boolean;
  loading?: boolean;
  children: React.ReactNode;
  className?: string | undefined;
};

export const BpSubpage: FC<BpSubpageProps> = ({ fullWidth, fullHeight, isForbidden, loading, children, className }) => {
  const classes = classNames(
    styles.subpage,
    { [styles['full-width']]: fullWidth, [styles['full-height']]: fullHeight },
    className,
  );

  return isForbidden ? (
    <ErrorState type='forbidden' />
  ) : (
    <div className={classes}>
      {loading && <LazyLoader size='xxl' borderRadius='m' className={styles.loader} />}
      {children}
    </div>
  );
};
